export default __webpack_public_path__ + "static/media/docs-burnout-info_en.91ad2da3.png";